import {
  helpResponseSchema,
  supportTicketSchema,
  type CreateSupportTicketInput,
  type HelpResponse,
  type Page,
  type SupportTicket,
  type SupportTicketListQuery,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

/** Readable signed out, so the help centre works before anyone has an account. */
export async function fetchHelp(): Promise<HelpResponse> {
  return helpResponseSchema.parse(await apiFetch<unknown>('/support', { auth: false }));
}

export async function createTicket(input: CreateSupportTicketInput): Promise<SupportTicket> {
  return supportTicketSchema.parse(await post<unknown>('/support/tickets', input));
}

export function fetchMyTickets(
  query: Partial<SupportTicketListQuery> = {},
): Promise<Page<SupportTicket>> {
  return fetchPage('/support/tickets', supportTicketSchema, query);
}
